import PropTypes from 'prop-types';

import Hero from '../../../Screens/Hero';

import Background from './Background';
import AnimatedCards from './AnimatedCards';

const PCOptimumHero = ({ data }) => {
  const { mediaimageDam } = data;
  return (
    <Hero
      data={data}
      bg={<Background />}
      media={<AnimatedCards imgs={mediaimageDam} />}
    />
  );
};

PCOptimumHero.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default PCOptimumHero;
